export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的战斗场面' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界的冒险之旅' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑故事' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常趣事' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '深刻动人的剧情佳作' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', description: '青春校园的成长故事' },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line', description: '细腻唯美的情感故事' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画' },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};